<template>
  <div class="donations-view container py-5 text-center">
    <h2 class="fw-bold text-gold mb-3">Support Our Temple</h2>
    <p class="text-muted mb-5">
      Your kind donations help us maintain the temple, support the monks, and
      fund community service programs.
    </p>

    <!-- Donation Info Cards -->
    <div class="row justify-content-center g-4 mb-5">
      <div class="col-12 col-md-5">
        <div class="card border-0 shadow-sm h-100 donation-card">
          <div class="card-body">
            <i class="bi bi-bank text-gold display-5 mb-3"></i>
            <h5 class="fw-bold text-gold">Bank Transfer</h5>
            <p class="mb-2">Account Name: Sri Sambuddha Viharaya</p>
            <p class="mb-2">Bank: Bank of Ceylon, Kandy Branch</p>
            <p class="mb-2">Account No: 123456789</p>
            <p class="mb-0">SWIFT Code: BCEYLKLX</p>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-5">
        <div class="card border-0 shadow-sm h-100 donation-card">
          <div class="card-body">
            <i class="bi bi-qr-code text-gold display-5 mb-3"></i>
            <h5 class="fw-bold text-gold">Scan to Donate</h5>
            <img
              src="@/assets/donation-qr.png"
              alt="QR Code"
              class="img-fluid mt-2 mb-2 rounded shadow-sm donation-qr"
            />
            <p class="text-muted small mb-0">
              Use any banking or wallet app to scan and donate securely.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Thank You Note -->
    <div
      class="alert alert-light border-start border-warning border-4 shadow-sm mx-auto thankyou-box"
    >
      <h6 class="fw-bold text-gold mb-1">🙏 Thank You!</h6>
      <p class="mb-0">
        Every contribution, no matter how small, supports the preservation of
        the Dhamma and the temple’s community mission.
      </p>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
.text-gold {
  color: #c69f59;
}

.card {
  border-radius: 12px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.1);
}

.donation-qr {
  max-width: 180px;
}

/* Thank You box styling */
.thankyou-box {
  max-width: 700px;
  border-radius: 12px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .donations-view {
    padding: 2rem 1rem !important;
  }

  h2 {
    font-size: 1.75rem;
  }

  .text-muted {
    font-size: 0.95rem;
  }

  .donation-card {
    padding: 0.5rem;
  }

  .donation-qr {
    max-width: 150px;
  }

  .thankyou-box {
    max-width: 95%;
    margin-top: 1.5rem;
    font-size: 0.95rem;
  }
}

@media (max-width: 576px) {
  h2 {
    font-size: 1.5rem;
  }

  .donations-view {
    padding: 1.5rem 0.5rem !important;
  }

  .donation-qr {
    max-width: 130px;
  }

  .thankyou-box {
    font-size: 0.9rem;
    padding: 1rem;
  }
}
</style>
